import React, {useState} from 'react';

import classNames from 'classnames';

import Count from '../../count/count';

export type TFilterValue = string | string[];

export interface IFilterProps {
    items: IFilterItemProps[];
    label: string;
    inputType?: 'radio' | 'checkbox';
    className?: string;
    onChange?: (value: TFilterValue) => void;
    value?: TFilterValue;
    defaultValue?: TFilterValue;
    hideLabel?: boolean;
}

export interface IFilterItemProps {
    id: string;
    label: string;
    name: string;
    value: string;
    count?: number;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    isRedBackground?: boolean;
}

const Filter = ({
    inputType = 'radio',
    defaultValue,
    value: propsValue,
    onChange,
    hideLabel,
    className,
    label,
    items,
}: IFilterProps): JSX.Element => {
    const initialValue: TFilterValue = inputType === 'checkbox' ? [] : '';
    const [value, setValue] = useState<TFilterValue>(defaultValue || initialValue);
    const isControlled: boolean = typeof propsValue !== 'undefined';
    const getValue: (inputValue?: TFilterValue) => TFilterValue = (inputValue?: TFilterValue): TFilterValue => {
        if (!inputValue) {
            return inputType === 'checkbox' ? [] : '';
        }

        return inputValue;
    };
    const controlledValue: TFilterValue = getValue(isControlled ? propsValue : value);
    const computedClassName: string = classNames(
        'filter',
        {
            'filter--hide-label': hideLabel,
        },
        className,
    );

    const handleChange = (itemValue: string): void => {
        const nextValue = getNextValue(controlledValue, itemValue, inputType === 'checkbox');

        if (!isControlled) {
            setValue(nextValue);
        }

        if (onChange) {
            if (inputType === 'checkbox') {
                onChange(nextValue);
            } else {
                onChange(nextValue.length ? nextValue : '');
            }
        }
    };

    return (
        <fieldset className={computedClassName}>
            <legend className="filter__label">
                {label}
            </legend>
            {items.map((item: IFilterItemProps, i: number) => {
                const onItemChange: (event: React.ChangeEvent<HTMLInputElement>) => void = (event: React.ChangeEvent<HTMLInputElement>) => {
                    handleChange(item.value);

                    if (item.onChange) {
                        item.onChange(event.target.checked);
                    }
                };
                const checked: boolean = controlledValue.includes(item.value);

                return (
                    <div className="filter__item" key={i}>
                        <input
                            checked={checked}
                            className="filter__input"
                            disabled={item.disabled}
                            id={item.id}
                            name={item.name}
                            onChange={onItemChange}
                            value={item.value}
                            type={inputType}
                        />
                        <label
                            className={'filter__indicator' + (item.isRedBackground === true ? ' red' : ' grey') + (checked ? ' checked' : '')}
                            htmlFor={item.id}
                        >
                            <span className="filter__indicator-inner">
                                <span className="filter__item-label">{item.label}</span>
                                {item.count && <Count className="filter__count" color={checked ? 'green' : 'grey'} number={item.count} size={'m'}/>}
                            </span>
                        </label>
                    </div>
                );
            })}
        </fieldset>
    );
};

const getNextValue = (currentValue: TFilterValue, itemValue: string, multiple: boolean = false): TFilterValue => {
    if (multiple && Array.isArray(currentValue)) {
        return currentValue.includes(itemValue) ? currentValue.filter((i) => i !== itemValue) : [...currentValue, itemValue];
    } else {
        return currentValue.includes(itemValue) ? '' : itemValue;
    }
};


export default Filter;
